const optionsDefaults = {
    elements:[
      {
        tag: 'input',
        type: 'text',
        className: 'input'
      },
      {
        tag: 'input',
        type: 'radio',
        className: 'radioButton'
      },
      {
        tag: 'input',
        type: 'checkbox',
        className: 'checkBox'
      },
      {
        tag: 'button',
        type: 'button',
        className: 'button'
      },
      {
        tag: 'a',
        className: 'link'
      },
      {
        tag: 'textarea',
        type: 'textarea',
        className: 'textarea'
      },
    ]
};

export default {
  install (Vue, opt) {
    let options = { ...optionsDefaults, ...opt };
    // console.log('Install plugin');
    let contextName;
    Vue.directive('enumerator', {
      componentUpdated: function(el, binding, vnode, oldVnode){
        if(typeof(binding.value) == "string") {
          contextName = binding.value;
          options.elements.forEach(function (item) {
            let list = el.getElementsByTagName(item.tag);
            if (list.length != 0) {
              let count = 1;
              for (let i = 0; i < list.length; i++) {
                let reClass = new RegExp(contextName + '-' + item.className + '-');
                if (list[i].className && list[i].className.match(reClass)) {
                  count++;
                }
              }
              for (let i = 0; i < list.length; i++) {
                let itemAttr = list[i].getAttribute("data-class-name");
                if (list[i].type && list[i].type !== item.type || itemAttr) {
                  continue
                }

                list[i].classList.add(contextName + '-' + item.className + '-' + count);
                list[i].setAttribute("data-class-name", contextName + '-' + item.className + '-' + count);
                count++;
                // console.log(list[i]);
              }
            }
          });
        } else{
          for (let key in binding.value){
            // console.log("Ключ: " + key + " значение: " + binding.value[key]);
            let list = el.getElementsByClassName(binding.value[key]);
            if (list.length != 0){
              let count = 1;
              for (let i = 0; i < list.length; i++) {
                let reClass = new RegExp(contextName + '-' + key + '-');
                if (list[i].className && list[i].className.match(reClass)) {
                  count++;
                }
              }
              for (let i = 0; i < list.length; i++) {
                let reClass = new RegExp(contextName + '-' + key + '-');
                if (list[i].className.match(reClass)) {
                  continue
                }
                let itemAttr = list[i].getAttribute("data-class-name");
                if (itemAttr){
                  list[i].classList.remove(itemAttr);
                }

                list[i].classList.add(contextName + '-' + key + '-' + count);
                list[i].setAttribute("data-class-name", contextName + '-' + key + '-' + count);
                count++;
              }
            }
          }
        }
      }
    });
  }
}